import { render, staticRenderFns } from "./UpmuAddDialog.vue?vue&type=template&id=58fdd209"
import script from "./UpmuAddDialog.vue?vue&type=script&lang=js"
export * from "./UpmuAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports